import React from 'react';
import PropTypes from 'prop-types';
import { graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { Heading, Text, Box } from '@chakra-ui/react';
import {ExternalLinkIcon} from '@chakra-ui/icons';
import getVideoId from 'get-video-id';
import { motion } from 'framer-motion';
import { useMediaQuery } from '@react-hook/media-query';
import { Helmet } from 'react-helmet';
import { getSrc } from 'gatsby-plugin-image';

function ProyectoCard(props) {
  const { data, darkMode, autoPlay } = props;
  const {
    title,
    description,
    video,
    cliente,
    fecha,
    image,
    date
  } = data.frontmatter;
  const { slug } = data.fields;
  const smallDevice = useMediaQuery('(max-width: 600px)');


  const url = `/proyectos${slug}`;
  // TODO use VideoSchema component
  const imageUrl = 'https://visualma.com' + 
    getSrc(image);
  const { id, service } =
    typeof video === 'string' ? getVideoId(video) : { id: null, service: null };
  let embedUrl = null;
  let isoDate = '';

  if (video && id && service === 'vimeo') {
    embedUrl = `https://player.vimeo.com/video/${id}`;
  } else if (service === 'youtube') {
    embedUrl = `https://www.youtube.com/embed/${id}`;
  }
  try {
    isoDate = new Date(date).toISOString();
  } catch (e) {
    // console.log('Invalid date for schema', e);
  }

  const videoSchema =
    video && id && embedUrl
      ? JSON.stringify({
        /* eslint-disable */
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "name": title,
        "description": description,
        "thumbnailUrl": imageUrl,
        "contentUrl": `https://visualma.com/proyectos${slug}`,
        "embedUrl": embedUrl,
        "uploadDate": isoDate
      })
      : null;
  {/* "duration": "PT1M33S",*/ }
  const autoPlaySettings = autoPlay ? '&mute=1&autoplay=1&muted=true&autoplay=true' : '&mute=0&autoplay=0&muted=false&autoplay=false'
  return (
    <Content >
      {videoSchema && (
        <Helmet>
          <script type="application/ld+json">{videoSchema}</script>
        </Helmet>
      )}
      <Link to={url ? url : ''}>
        <motion.div
          initial={{ scale: 1 }}
          whileHover={smallDevice ? { scale: 1 } : { scale: 1.1 }}
          whileTap={smallDevice ? { scale: 1 } : { scale: 0.95 }}
          style={{ height: '100%' }}
        >
          <Box
            bg="white"
            height="100%"
            borderRadius="0px"
            overflow="hidden"
            marginBottom="4"
            // boxShadow="2px 2px 6px rgba(0, 0, 0, 0.3)"
            className={darkMode ? 'shadow-md' : 'shadow-md-white'}
          >
            {video ? (
              <Box background="#000">
                <iframe
                  loading="lazy"
                  src={`${video}?byline=0&amp;portrait=0&vq=hd1080&modestbranding=1&color=red&iv_load_policy=3&rel=0${autoPlaySettings}&playlist=${id}&loop=1&loop=true&byline=false&title=false`}
                  title={`Video de ${title}`}
                  width="100%"
                  // height="365px"
                  frameBorder="0"
                  className="headerVideo"
                  style={{ height: '260px', width: 'calc(100%)' }}
                  allowFullScreen={true}
                ></iframe>
              </Box>
            )
            : (
                <GatsbyImage
                  image={image.childImageSharp.gatsbyImageData}
                  alt={`${title} en México`}
                  style={{ margin: '0 auto' }} />
              )
            }
            
            <Heading as="h4" textAlign="center" className="textoGrad2" paddingTop="0.5em" paddingBottom="0.3em" margin="1.3em 0 1em">
              {title}
            </Heading>
            {/* <Text
              className="descripcion"
              m="1em 12px"
              textDecoration="none"
              color="black"
              overflow="auto"
              height="133px"
            >
              {description}
            </Text> */}
            <Text textAlign="right" padding="0.3em 1em 0em" color={ darkMode ? '#999' : '#444'}>
              {fecha && (
                `Creado en ${fecha} `
              )}
              {cliente && (
                `para ${cliente} `
              )}

              <ExternalLinkIcon ml="2" mb="1" style={{ color: '#1f9ee4'}} />
            </Text>
          </Box>
        </motion.div>
      </Link>



    </Content>
  );
}
ProyectoCard.propTypes = {
  data: PropTypes.object,
  darkMode: PropTypes.bool,
  autoPlay: PropTypes.bool,
};

export const query = graphql`fragment ProyectoCardData on Mdx {
  frontmatter {
    title
    description
    video
    cliente
    fecha
    image {
      childImageSharp {
        gatsbyImageData(width: 498, layout: CONSTRAINED, formats: [AUTO, WEBP, AVIF])
      }
    }
    date
  }
  fields {
    slug
  }
}
`;

const Content = styled.div`

  width: 100%;
  max-width: 100%;
  padding: 2rem 3rem;
  font-size: 1.4em;
  line-height: 1.3em;
  
  @media (max-width: 420px) {
    padding: 2rem 0rem;
  }
  h4 {
    font-size: 0.8em;
    line-height: 1.2;
    text-align: center ;
    margin: 1em 0;
  }
  p {
    font-size: 14px;
    line-height: 1.2;
  }
  img {
    max-width: 100%;
    margin: 0 auto;
  }
  a {
    color: #2288cc;
  }
  
`;

export default ProyectoCard;
